<template>
    <div>
        <app-navigation/>
        <app-banner
          backgroundUrl="/publications/publications-header-1.png"
          :headerButtons="[]"
          backgroundSize="cover"
          title="Curated data at your fingertips"
          description="A wide collection of data curated for your needs."
        />
        <div style="text-align: center; background-color: white; padding: 3%;">
            <v-tabs v-model="active" centered grow style="width: 100%;">
              <v-tab v-for="tab in tabs" :key="tab.key" class="tab-heading">
                {{ tab.title }}
              </v-tab>
              <v-tab-item v-for="tab in tabs" :key="tab.key" style="padding-bottom: 3%; padding-top: 3%;">
                <div class="text-field-wrapper">
                  <v-text-field
                  style="width: 30%;"
                  type="text"
                  v-model="searchQuery"
                  placeholder="Search..."
                  @input="onSearch"
                  />
                </div>
                <table class="article-table" :v-if="!loading" >
                  <thead>
                    <tr>
                      <th class="col-auto"><h3>Title</h3></th>
                      <th class="col-fixed"><h3>Authors</h3></th>
                      <th class="col-fixed mobile-hide"><h3>Publication Date</h3></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="
                      (article, index) in publications[tab.key].filter(item => {return (
                        item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        item.authors.toLowerCase().includes(searchQuery.toLowerCase())
                      )}).slice(0, visibleCount)" :key="index" :class="{ shaded: index % 2 === 0 }">
                      <td>
                        <a :href="article.link" class="title-link">{{ article.title }}</a>
                      </td>
                      <td>{{ article.authors }}</td>
                      <td class="mobile-hide">{{ article.date }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="show-more-container" v-if="publications[tab.key].filter(item => {return (
                        item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        item.authors.toLowerCase().includes(searchQuery.toLowerCase())
                      )}).length > visibleCount">
                  <button @click="showMore" class="show-more-button">
                    Show next 10
                  </button>
                </div>
              </v-tab-item>
            </v-tabs>
          </div>
        <app-footer/>
    </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/AppNavigation.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppBanner from '@/components/AppBanner.vue'
import axios from 'axios';

export default {
  name: 'Publications',
  components: {
      AppNavigation,
      AppFooter,
      AppBanner
  },
  data: () => ({
      visibleCount: 10,
      mobile: null,
      searchQuery: "",
      windowWidth: null,
      publications: null,
      tabs: [
        {key: 'peer_reviewed', title: 'Peer Reviewed'},
        {key: 'global_biosecurity', title: 'Global Biosecurity'},
        {key: 'watching_briefs', title: 'Watching Briefs'}
      ],
      loading: true
    }),
  created() {
      window.addEventListener('resize', this.checkScreen);
      this.checkScreen();
    },
    destroy() {
      window.removeEventListener('resize', this.checkScreen)
    },
    async mounted() {
      this.checkScreen();
      this.fetch_publications().then((data) => {
        this.publications = data
        this.loading = false
      })
    },
    methods: {
      
      showMore() {
        this.visibleCount = this.visibleCount + 10;
      },
      checkScreen() {
        this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 1000) {
          this.mobile = true;
        } else {
          this.mobile = false;
        }
        return;
      },
      fetch_publications() {
        return new Promise((resolve, reject) => {
          axios.get("../data/publications.json").then((response) => {
            resolve(response.data)
          })
          .catch((e) => {
            reject(e)
          })
          .finally(() => {})
        })
      }
    }
  
}
</script>

<style>
.v-btn__content {
  width: 100%;
  white-space: normal;
}

a {
  text-decoration: none;
}
</style>